import React, { useState, useEffect } from "react";
import Grid from '@material-ui/core/Grid'
import SearchIcon from '@material-ui/icons/Search';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'; 
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import OpenInNewOutlinedIcon from '@material-ui/icons/OpenInNewOutlined';

import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import CardPairs from '../../Components/Cards/cardspair'
import '../browser.css'

import srcimg from '../../img/brow/pancakeswaplogo.png'
// import cakeimg from '../../img/brow/pacnckagebackgroundlight.png'


const Pairs = () => {
  const [useContent, setContent] = useState('closeModel')

  const [allData,setAllData] = useState([]);
  const [filteredData,setFilteredData] = useState(allData);

  const pairModel = (status) =>{
    setContent(status);   
  }
  /*******************
  *
   Search Bar
  *
  ********************/
   useEffect(() => {
    const requestOptions = {
      method: 'GET',
      headers: {
          'Content-Type': 'application/json',
      },
    };
    fetch('https://coinvanci-g.herokuapp.com/category',requestOptions)
    .then(response => response.json())
    .then(response => {
    console.log('fectumTest: ', response)
    setAllData(response);
    setFilteredData(response);
    })
    .catch(error => {
    console.log('Error getting fake data: ' + error);
    })
    }, []);

    const handleSearch = (event) => {
      let value = event.target.value.toLowerCase();
      let result = [];
      // result = allData.filter((data) => {
      //   let tesfer = "";
      //   // tesfer = tesfer = data.Title.search(value) != -1;
      //   // tesfer = data.address.search(value)!= -1;
      //   return (
      //     data.Title.search(value)!= -1
      //   );
      // });
      let str = value;
      let res = str.substring(0, 2);
      if( res == '0x' ){
        result = allData.filter(x => x.address.toLowerCase().includes(value.toLowerCase()));
      }else{
        result = allData.filter(x => x.Title.toLowerCase().includes(value.toLowerCase()));
      }
      setFilteredData(result);
    }

   if(useContent == "closeModel"){
    return (
        <div className="pcc---slider" style={{backgroundColor:'#f6f6f6'}}>
                <Grid
                    container
                    justify="center"
                    alignItems="center"
                    className="px-0"
                >
                    <Grid 
                        container 
                        justify="center" 
                        direction="column"
                        md={8}
                        className="py-md-3"
                    >
                    <Grid 
                        container 
                        justify="center" 
                        alignContent="center"
                        direction="column"
                        md={12}
                    >
                        <h2 className="text-center mb-0"><strong>$13.21M</strong></h2>
                        <p>total value locked in 74 pairs</p>
                        <button className="pcc---infoButton mb-5" onClick={()=>pairModel('lquidity')}><LockOutlinedIcon /> Lock Liquidity</button>
                    </Grid>
                    <Grid 
                        container 
                        justify="center" 
                        direction="column"
                        md={12}
                    >
                        <div className='pc---input mb-4'>
                        <img src={srcimg} for="#search" />
                        <input type="text" onChange={(event) =>handleSearch(event)} id="search" placeholder="Token name or address" />
                        <SearchIcon  for="#search"  />
                        </div>
                    </Grid>
                    <Grid 
                        container 
                        justify="center" 
                        direction="column"
                        md={12}
                    >
                        <div style={{maxWidth:'-webkit-fill-available'}}>
                        {filteredData.map((value,index)=>{
                        return(
                        <div key={value.id}>
                            <div >
                            <CardPairs pairModel={pairModel} />
                            {value.id} {value.Title} {value.address}<br />
                            </div>
                        </div>
                        )
                        })}
                        </div>
                    </Grid>
                    </Grid>
                </Grid>
        </div> 
      );
   }else if(useContent == "openModel"){
    return (
        <div className="pcc---slider" style={{backgroundColor:'#f6f6f6'}}>
                <Grid
                container
                justify="center"
                alignItems="center"
                className="px-0"
                >
                <Grid 
                    container 
                    justify="center" 
                    direction="row"
                    xs={12}
                    md={8}
                    className="p-4 p-md-5"
                    style={{backgroundColor:'#fff',borderRadius:5,boxShadow:'0px 0px 5px #868686'  }}
                >
                    <Grid 
                    container 
                    justify="center" 
                    direction="column"
                    xs={6}
                    >
                    <div className="text-left">
                        <button onClick={()=>pairModel('closeModel')} className="pcc---model_close_btn mb-4" ><ArrowBackIosOutlinedIcon /></button>
                    </div>
                    </Grid>
                    <Grid 
                    container 
                    direction="row"
                    justify="flex-end" 
                    alignItems="flex-end"
                    xs={6}
                    >
                    <button className="pcc---infoButton mr-0 mb-4"><LockOutlinedIcon /> Lock Liquidity</button>
                    </Grid>
                <Grid 
                    container 
                    justify="center" 
                    direction="column"
                    alignContent="center"
                    alignItems="center"
                    xs={12}
                >
                    <h2 className="mb-1 text-center">
                    <img src={srcimg} className="mr-2" style={{width: 35}}/>
                    <strong>WBNB / BUSD</strong>
                    </h2>
                    <p className="m-0">Wrapped BNB / BUSD</p>
                    <a href="#" className="pcc---infoLInks mb-3">
                    0x877.....ce86 <FileCopyOutlinedIcon />
                    </a>
                    <Grid 
                    container 
                    justify="center" 
                    direction="row"
                    xs={12}
                    >
                    <a href="#" className="pr-3 pcc---infoLInks">
                        BscScan <OpenInNewOutlinedIcon />
                    </a>
                    <a href="#" className="pcc---infoLInks">
                        Pancakeswap V2 <OpenInNewOutlinedIcon />
                    </a>
                    </Grid>
                </Grid>
                <Grid 
                    container 
                    direction="row"
                    justify="space-between" 
                    alignContent="center"
                    alignItems="center"
                    xs={12}
                >
                    <p className="mb-0">Total LP tokens</p>
                    <p className="mb-0">221,955,034.6696</p>
                </Grid>
                <Grid 
                    container 
                    direction="row"
                    justify="space-between" 
                    alignContent="center"
                    alignItems="center"
                    xs={12}
                >
                    <p className="mb-0">Total locked LP</p>
                    <p className="mb-0">192,860,765.923</p>
                </Grid>
                <Grid 
                    container 
                    direction="row"
                    justify="flex-start" 
                    xs={12}
                    className="my-4"
                >
                    <h5 className="mb-0">Liquidity Locks</h5>
                    <p className="mb-0">Please be aware only the univ2 tokens are locked. Not the actual dollar value. This changes as people trade. More liquidity tokens are also minted as people add liquidity to the pool.</p>
                </Grid>
                <Grid 
                    container 
                    direction="column"
                    justify="flex-start" 
                    alignItems="flex-start"
                    xs={6}
                >
                    <p className="mb-0">Total locked LP</p>
                    <h5 className="mb-0">$0</h5>
                    <p className="mb-0">192,860,765.923</p>
                </Grid>
                <Grid 
                    container 
                    direction="column"
                    justify="flex-end" 
                    alignItems="flex-end"
                    xs={6}
                >
                    <p className="mb-0">Unlock date</p>
                    <h5 className="mb-0">in 2 years</h5>
                    <p className="mb-0">25/04/2023 12:00</p>
                </Grid>
                </Grid>
                
                </Grid>
        </div> 
      );
   }else if(useContent == "lquidity"){
    return (
        <div className="pcc---slider" style={{backgroundColor:'#f6f6f6'}}>
                <Grid
                    container
                    justify="center"
                    alignItems="center"
                    className="px-0"
                >
                    <Grid 
                        container 
                        justify="center" 
                        direction="column"
                        md={8}
                        className="py-md-3"
                    >
                    <Grid 
                        container 
                        justify="center" 
                        alignContent="center"
                        direction="row"
                        md={12}
                    >
                        <button className="pcc---infoButton mb-5" onClick={()=>pairModel('lquidity')}><LockOutlinedIcon /> New Lock</button>
                        <button className="pcc---infoButton mb-5" onClick={()=>pairModel('lquidity')}><LockOutlinedIcon /> Withdraw</button>
                    </Grid>
                    <Grid 
                        container 
                        justify="center" 
                        direction="column"
                        md={12}
                    >
                        <button className="pcc---infoButton mb-5" onClick={()=>pairModel('closeModel')}><LockOutlinedIcon /> Back</button>
                    </Grid>
                    <Grid 
                        container 
                        justify="center" 
                        direction="column"
                        md={12}
                    >
                        <h3>Lock Liquidity</h3>
                    </Grid>
                    <Grid 
                        container 
                        justify="center" 
                        direction="column"
                        md={12}
                    >
                        <div style={{maxWidth:'-webkit-fill-available'}}>
                        {filteredData.map((value,index)=>{
                        return(
                        <div key={value.id}>
                            <div >
                            <CardPairs pairModel={pairModel} />
                            {value.id} {value.Title} {value.address}<br />
                            </div>
                        </div>
                        )
                        })}
                        </div>
                    </Grid>
                    </Grid>
                </Grid>
        </div> 
      ); 
   }
  
}

export default Pairs;
